import {Injectable} from '@angular/core';
import {BackgroundMode} from '@anuradev/capacitor-background-mode';
import {Api} from '../api/api';
import {PatientDataProvider} from '../patient-data/patient-data';
import {AlertController} from '@ionic/angular';
import {Logger} from 'ionic-logging-service';
import {SipProvider} from '../sip/sip';
import {IncommingCallPageComponent} from '../../shared/modals/incomming-call/incomming-call';
import {ChatPageComponent} from '../../shared/modals/chat/chat';
import {ModalService} from '../modal.service';
import { AudioService } from '../audio/audio.service';
import { Subscription } from 'rxjs';

declare let window: any;

@Injectable()
export class SipRegisterProvider {

  cancelCnt: boolean = null;
  private peerAudio: HTMLAudioElement;
  actionAllowed = false;
  navbarColor = '';
  private logger: Logger;
  private event1: Subscription;
  private event2: Subscription;
  private event3: Subscription;
  private event4: Subscription;
  private event5: Subscription;
  private event6: Subscription;
  private event7: Subscription;

  constructor(public api: Api, public patientDataProvider: PatientDataProvider,
              private modalCtrl: ModalService, private sipProvider: SipProvider, private alertCtrl: AlertController, private audio:AudioService) {
      this.peerAudio = new window.Audio();
      this.audio.preload('endplingaudio', 'endpling.mp3');

      this.api.socket.removeAllListeners('sip');
      this.api.socket.on('sipReConnect', this.reConnect.bind(this));
  }

  private getLogger() {
    if(this.logger) {
      return this.logger;
    }

    return this.logger = this.api.getLogger('Hausnotruf.AlertInputComponens');
  }

  reConnect(data) {
    if (this.sipProvider.inputReady === data) {
      console.log('ReconnectSip Event');
      this.sipProvider.unregister();
      this.sipProvider.registerSIPConnection();
    }
  }


  async incomingCall(session) {
		const active = await BackgroundMode.isActive();

    if (active.activated) {
      if (this.api.platform.is('android')) {
        await BackgroundMode.wakeUp();
        await BackgroundMode.moveToForeground();
        await BackgroundMode.unlock();
      }
		}

		const m = session.remote_identity.uri.toString().match(/sip:(.*)@/);
		let name = 'Unbekannt';

		if (m) {
      let find:Array<any>;
			const contacts:Array<any> = await this.patientDataProvider.getContacts(m[1]);

      if(contacts.length === 1) {
        find = contacts;
      } else {
        find = contacts.filter((elm) => {
          return elm.code === m[1];
        });
      }
			
			if (find.length) {
				name = find[0].firstname + ' ' + find[0].lastname;
			} else {
        name = await this.getNameByNumber(m[1]);
      }
		}
		await this.modalCtrl.openModal(
      IncommingCallPageComponent,
    {
      callerName: name
    },
    {
      cssClass: 'incoming-call-modal',
    });
  }


    getNameByNumber(number): Promise<string> {
      return new Promise((resolve) => {
        const query = {
          selector: {
            'management.deviceFonNumber': {
              $eq: number
            }
          },
          fields: ['addressData.firstname', 'addressData.lastname']
        };

        this.patientDataProvider.api.get('patientData', query).subscribe((res: any) => {
          if (res.data.data.data.docs.length) {
            resolve(res.data.data.data.docs[0].addressData.firstname + ' ' + res.data.data.data.docs[0].addressData.lastname);
          } else {
            resolve('Unbekannt');
          }
        });
      });
    }

    socketAlive() {
      this.sipProvider.socketAlive();
    }


  init() {
    const homeonUpdateUI = (session) => {
      if (session) {
        if (session.isInProgress()){
        if (session.direction === 'incoming'){
          this.incomingCall(session);
        } else {
          // this.incomingCall = false;
        }
        }
      } else {
        this.cancelCnt = null;
      }
      };

    if(this.event1) {
      this.event1.unsubscribe();
    }

    this.event1 = this.sipProvider.events.subscribe('onUpdateUI', homeonUpdateUI);

    const homeonRemoteStream = (stream) => {
      this.peerAudio.srcObject = stream;
      this.peerAudio.play();
      };

    if(this.event2) {
      this.event2.unsubscribe();
    }
    this.event2 = this.sipProvider.events.subscribe('onRemoteStream', homeonRemoteStream);

    const homeonProgress = () => {
      this.cancelCnt = true;
      };

    if(this.event3) {
      this.event3.unsubscribe();
    }
    this.event3 = this.sipProvider.events.subscribe('onProgress', homeonProgress);

    const homeonFailed = async (ev: any) => {
      this.cancelCnt = null;
      if (ev.message && ev.message.status_code === 404) {
        const alert = await this.alertCtrl.create({
          header: 'Fehler',
          message: 'Der Teilnehmer ist im moment nicht zu erreichen',
          buttons: ['OK']
        });
        alert.present();
        }
      };

    if(this.event4) {
      this.event4.unsubscribe();
    }
    this.event4 = this.sipProvider.events.subscribe('onFailed', homeonFailed);


    const homeonEnded = () => {
      this.cancelCnt = null;
      setTimeout(() => {
          this.actionAllowed = false;
          this.navbarColor = 'default';
          this.audio.play('endplingaudio');
        }, 2000);
      };

    if(this.event5) {
      this.event5.unsubscribe();
    }
    this.event5 = this.sipProvider.events.subscribe('onEnded', homeonEnded);

    const homeonTrack = (trackEv) => {
      if (trackEv.track.kind === 'audio') {
        this.peerAudio.srcObject = (trackEv.streams[0]);
        this.peerAudio.play();
      }
      console.log(trackEv.track.kind);
      };

    if(this.event6) {
      this.event6.unsubscribe();
    }
    this.event6 = this.sipProvider.events.subscribe('onTrack', homeonTrack);

    const homeChatReceived = async (msg: any) => {
      let userName = 'Unbekannt';
      const contacts  = await this.patientDataProvider.getContacts();
      const find = contacts.filter((contact) => {
        return contact.code === msg.userId;
      });

      if (find.length) {
        userName = find[0].firstname + ' ' + find[0].lastname;
      }

      if (!document.querySelector('app-page-chat')) {
        await this.modalCtrl.openModal(ChatPageComponent, {
          toUserId: msg.userId,
          toUserName: userName,
        }, {
          cssClass: 'chatModal'
        });
      }
      };

    if(this.event7) {
      this.event7.unsubscribe();
    }
    this.event7 = this.sipProvider.events.subscribe('chat:received', homeChatReceived);


    localStorage.setItem('prom', this.api._user.user_id);

    if (!this.sipProvider.myua || !this.sipProvider.myua.isRegistered()) {
      this.sipProvider.registerSIPConnection().then(async () => {
        this.getLogger().info('sipRegister', { register: this.sipProvider.myua.isRegistered(), prom: this.api.getProm()});
      })
        .catch((_err) => {
          this.getLogger().error('sipRegister', { register: this.sipProvider.myua.isRegistered(), prom: this.api.getProm()});
        });
    }
  }

}
